import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';
import {WidgetEmb} from './WidgetEmb';

export class PhysicalTemplate extends BasicEntity {
code: string;
color: string;
description: TranslatedEmb;
label: TranslatedEmb;
screenMode: string;
visionCode: string;
widgets: WidgetEmb[];
}

